
export function size(size: number) {
    return size * 12 + "px";
}